import { Injectable } from "@angular/core";
import { CustomHttpClient } from "src/app/providers/CustomHttpClient";

@Injectable({
    providedIn: 'root'
})
export class ModuloService {
    constructor(private http: CustomHttpClient) { }

    Get(idUsuario: number) {
        return this.http.Get("api/modulo/Get/" + idUsuario);
    }
}